/**
 * Utilidades para la página de confirmación de pago
 */

import { WHATSAPP_NUMBER, STATUS_MAPPING, PAYMENT_STATUS } from './constants';

/**
 * Genera el mensaje de WhatsApp con los datos del pago
 * @param {string} paymentId - ID del pago
 * @returns {string} URL de WhatsApp con el mensaje
 */
export const generateWhatsAppMessage = (paymentId = '') => {
  let message = '¡Hola! Acabo de realizar una compra en Fe en Juego.\n\n';
  
  if (paymentId) {
    message += `*Código de pago:* ${paymentId}\n\n`;
  }
  
  message += 'Te envío mis datos para la entrega:\n\n';
  message += '- *Nombre completo:* \n\n';
  message += '- *Dirección:* \n\n';
  message += '- *Teléfono:* \n\n';
  message += '- *Forma de entrega:* (retiro/envío)';
  
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

/**
 * Genera el mensaje de WhatsApp para soporte
 * @returns {string} URL de WhatsApp con el mensaje de ayuda
 */
export const generateSupportMessage = () => {
  const message = 'Hola, tuve un problema con mi pago en Fe en Juego y necesito ayuda.';
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

/**
 * Genera el mensaje de WhatsApp para notificar pago pendiente
 * @param {string} paymentId - ID del pago pendiente
 * @returns {string} URL de WhatsApp con el mensaje de notificación
 */
export const generatePendingPaymentMessage = (paymentId = '') => {
  let message = '¡Hola! Mi pago en Fe en Juego está pendiente.\n\n';
  
  if (paymentId) {
    message += `*Código de transacción:* ${paymentId}\n\n`;
  }
  
  message += 'Quisiera confirmar el estado de mi pago.';
  
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

/**
 * Determina el estado del pago basado en los parámetros de URL
 * @param {URLSearchParams} searchParams - Parámetros de la URL
 * @returns {Object} Estado del pago y ID
 */
export const determinePaymentState = (searchParams) => {
  const status = searchParams.get('status');
  const collectionStatus = searchParams.get('collection_status');
  const paymentIdParam = searchParams.get('payment_id');
  const merchantOrderId = searchParams.get('merchant_order_id');
  
  // Determinar el ID del pago
  const paymentId = paymentIdParam || merchantOrderId || '';
  
  // Determinar el estado del pago
  let paymentState = PAYMENT_STATUS.WAITING;
  
  if (status && STATUS_MAPPING[status]) {
    paymentState = STATUS_MAPPING[status];
  } else if (collectionStatus && STATUS_MAPPING[collectionStatus]) {
    paymentState = STATUS_MAPPING[collectionStatus];
  } else if (status || collectionStatus) {
    paymentState = PAYMENT_STATUS.WAITING;
  }
  
  return { paymentState, paymentId };
};

